import {
  Button,
  Heading,
  Page,
  Modal,
  TextContainer,
  Banner
} from '@superops/ui-design-system';
import { useMutation } from '@apollo/client';
import { isEmpty } from 'lodash';
import React, { useEffect, useState, useCallback } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { getTranslatedText, toast } from '@nile/components';
import { AccountClient } from '@nile/graphql';
import Loading from '@nile/components/src/Svg/AnimatedSvg/Loading.svg';
import {
  GET_DOWNLOAD_INVENTORY_LIST,
  DELETE_PDF_HISTORY
} from '@nile/reports/src/modules/reports/graphql';
import envConfig from '@nile/home/src/Config/env';
import {
  PDF_REPORT,
  PDF_REPORT_MAP
} from '@nile/reports/src/modules/home/constants';
import { SVGIcon } from '@superops/super-icons';
import HistoryTable from '../HistoryTable';

function PDFReportSheet(props) {
  const { data, reportType, intl } = props;
  const [records, setRecords] = useState([]);
  const [enalbeResolveAction, setEnalbeResolveAction] = useState(false);
  const [active, setActive] = useState(false);
  const handleChange = useCallback(() => setActive(!active), [active]);

  const [pdfData, setData] = useState([]);
  const [pdfDataLoading, setDataLoading] = useState(true);

  const options = {
    pageSize: 50,
    page: 1,
    sort: [
      {
        attribute: 'triggeredTime',
        order: 'DESC'
      }
    ]
  };

  const context = {
    setRecords,
    records
  };

  const activeReports = PDF_REPORT_MAP?.find(
    (rep) => rep.id === data?.reportId
  );

  const fetchViewData = async () => {
    const requestOption = {
      module: 'REPORT',
      moduleSpecificId: data.reportId,
      listInfo: {
        ...options
      }
    };
    await AccountClient.query({
      query: GET_DOWNLOAD_INVENTORY_LIST,
      variables: requestOption,
      fetchPolicy: 'network-only'
    }).then((res) => {
      setDataLoading(false);
      setData(res?.data?.getDownloadInventoryList?.inventoryList);
    });
  };

  useEffect(() => {
    if (reportType === PDF_REPORT) {
      fetchViewData();
    }
  }, []);

  useEffect(() => {
    if (records && records?.length > 0) {
      setEnalbeResolveAction(true);
    } else {
      setEnalbeResolveAction(false);
    }
  }, [records]);

  const activator = (
    <Button
      onClick={handleChange}
      icon={<SVGIcon name="Delete" />}
      disabled={!enalbeResolveAction}
    >
      <FormattedMessage id="common.delete" />
    </Button>
  );

  const [deletePdfHistory] = useMutation(DELETE_PDF_HISTORY, {
    client: AccountClient,
    onCompleted: (res) => {
      if (res) {
        toast('success', 'toast.reports.history.delete.success', undefined, {
          reportType: 'PDF'
        });
        setRecords([]);
      }
    },
    onError: () => {
      toast('error', 'error.page.config.default.title');
    }
  });

  const actionClickDelete = (e, callback) => {
    if (e) {
      //tableInline single pdf history delete
      deletePdfHistory({
        variables: {
          ids: [e.inventoryId]
        }
      }).then(() => {
        if (callback) callback();
      });
    } else {
      //bulk pdf history delete
      deletePdfHistory({
        variables: {
          ids: records.map((item) => item.inventoryId)
        }
      }).then(() => {
        fetchViewData();
      });
    }
  };
  const banner =
    activeReports?.id === '10008' ? (
      <div className="mr-16 f-14  mt-10">
        <Banner status="info">
          <FormattedMessage id="software.activityreport.banner" />
        </Banner>
      </div>
    ) : null;
  return (
    <>
      {!isEmpty(pdfData) ? (
        <>
          <div className="p20 full-height fw">
            <Page
              contentHeight={banner ? '115px' : '80px'}
              variant="secondary"
              divider
              fullWidth
              additionalMetadata={<>{banner}</>}
              title={
                <div className="pt-5 pb-5">
                  <Heading element="h2">
                    <FormattedMessage id="common.previous.download" />
                  </Heading>
                </div>
              }
              primaryAction={
                <>
                  {records.length > 0 && (
                    <div className="fx">
                      <Button outline selected>
                        {records.length}{' '}
                        <FormattedMessage id="rmm.patchManagement.bulkActions.selected" />
                      </Button>

                      <div className="ml-10">
                        <Modal
                          activator={activator}
                          open={active}
                          onClose={handleChange}
                          variant="confirmation"
                          title={getTranslatedText(
                            intl,
                            'reports.history.bulkAction.heading',
                            {
                              reportType: 'PDF'
                            }
                          )}
                          primaryAction={{
                            destructive: true,
                            content: getTranslatedText(intl, 'common.delete'),
                            onAction: () => {
                              handleChange();
                              actionClickDelete();
                            }
                          }}
                          secondaryActions={[
                            {
                              content: getTranslatedText(intl, 'common.cancel'),
                              onAction: handleChange
                            }
                          ]}
                        >
                          <TextContainer>
                            <FormattedMessage
                              id="reports.history.bulkAction.description"
                              values={{ reportType: 'PDF' }}
                            />
                          </TextContainer>
                        </Modal>
                      </div>
                    </div>
                  )}
                </>
              }
            >
              <HistoryTable
                data={data}
                context={context}
                actionClickDelete={actionClickDelete}
                enableDeleteAction
              />
            </Page>
          </div>
        </>
      ) : (
        <>
          {!pdfDataLoading && isEmpty(pdfData) ? (
            <div>
              {banner}
              <div className="pdf-reportwrap px-20 pd-y20 fw">
                <div className="pdf-report-img-wrap fx pb20 w900 mauto">
                  <img
                    className="fw"
                    src={`${envConfig.imageRoot}svg/${activeReports?.sampleReportImgUrl}.svg`}
                    alt={data?.title}
                  />
                </div>
              </div>
            </div>
          ) : (
            <div className="flex-center full-height w100px">
              <Loading />
            </div>
          )}
        </>
      )}
    </>
  );
}

export default injectIntl(PDFReportSheet);
